import { LeoGlyph } from "@libs/zapi-ui/ds/components/leo-wordmark";
import { cn } from "@/zapi-frontend/shared/lib/utils";

export function LeoAvatar({ className }: { className?: string }) {
  return (
    <span data-slot="leo-avatar" className={cn("flex size-8 shrink-0 items-center justify-center text-leo", className)}>
      <LeoGlyph className="size-[55%]" title="" />
    </span>
  );
}
